import React from 'react';
import { Link } from 'react-router-dom';
import { LogOut, UserRound, Calculator } from 'lucide-react';
import { AlertsToggle } from './AlertsToggle';

export const TradeHeader = ({ onLogout, isAdmin }) => (
  <header className="flex flex-wrap items-center justify-between gap-3 border-b border-white/5 px-4 py-4 sm:px-8" data-testid="trade-header">
    <div className="flex items-center gap-3">
      <span className="sim-display text-lg font-bold text-white">Trade Blindfolded</span>
    </div>
    <nav className="flex items-center gap-2 text-sm">
      <AlertsToggle />
      {isAdmin && (
        <Link to="/calculator-classic" className="flex items-center gap-1.5 rounded-full px-3 py-1.5 text-slate-400 transition-colors hover:bg-white/5 hover:text-white" data-testid="nav-classic-calculator">
          <Calculator size={15} /> Classic
        </Link>
      )}
      <Link to="/profile" className="flex items-center gap-1.5 rounded-full px-3 py-1.5 text-slate-300 transition-colors hover:bg-white/5 hover:text-white" data-testid="nav-profile">
        <UserRound size={15} /> Profile
      </Link>
      <button type="button" onClick={onLogout} className="flex items-center gap-1.5 rounded-full px-3 py-1.5 text-slate-400 transition-colors hover:bg-white/5 hover:text-white" data-testid="nav-logout">
        <LogOut size={15} /> Logout
      </button>
    </nav>
  </header>
);
